import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Button } from 'semantic-ui-react';
import HotelsDropDown from '../../components/shared/HotelsDropDown';
import { useTextResources } from '../../language';
import { isMobileOnly } from 'mobile-device-detect';
import TransactionsDropDown from '../../components/shared/TransactionsDropDown';
import EntityTypesDropDown from '../../components/shared/EntityTypesDropDown';
import TextInput from '../../components/shared/TextInput';
import DynamicEntityDropDown from '../../components/shared/DynamicEntityDropDown';
import { EntityType } from '../../components/shared/constants';
import { useMessageResources } from '../../language';
import { onWarning } from '../../components/shared/messages';
import _ from 'lodash';


export const EditModal = ({
  extendedProps: {
    data,
    hotels,
    transactionData,
    roomsData,
    roomsTypeData,
    wingsData,
    marketSegmentData
  },
  row,
  onCancelChanges,
  onApplyChanges,
  onChange,
  open
}) => {

  const text = useTextResources()
  const message = useMessageResources()

  const validationData = () => {
    // checks an existing row with no changes
    if (row.Id && _.isEqual(row, data.filter(d => d.Id == row.Id)[0]))
      return true
    //else checks duplicate rows  
    var duplicateData = data.filter(d => d.HotelId == row.HotelId && d.TransactionCodeId == row.TransactionCodeId && d.EntityTypeId != row.EntityTypeId)
    if (duplicateData.length > 0)
    {
        onWarning(message('CannotAllowDuplicatedMapping'))
        return false
    }

    duplicateData = data.filter(d => d.HotelId == row.HotelId && d.TransactionCodeId == row.TransactionCodeId &&  d.EntityId == row.EntityId)
    if (duplicateData.length == 0)
      return true
      
    onWarning(message('CannotAllowDuplicatedMapping'))
    return false

  }

  const isSaveDisabled = () => {
    return !(
      row.HotelId &&
      row.EntityId &&
      row.EntityTypeId &&
      row.TransactionCodeId &&
      row.AccountingSystemNum &&
      validationData()
    );
  };

  const dynamicEntityLabel = ({ EntityTypeId }) => {
    return {
      [EntityType.Room]: text('Rooms'),
      [EntityType.RoomType]: text('RoomTypes'),
      [EntityType.Wings]: text('Wings'),
      [EntityType.MarketSegment]: text('MarketSegment'),
    }[EntityTypeId];
  };

  const dynamicEntityDropDownData = ({ EntityTypeId }) => {
    return {
      [EntityType.Room]: roomsData.filter(r => r.HotelId == row.HotelId),
      [EntityType.RoomType]: roomsTypeData,
      [EntityType.Wings]: wingsData.filter(w => w.HotelID == row.HotelId),
      [EntityType.MarketSegment]: marketSegmentData
    }[EntityTypeId];
  };

  return (
    <Modal
      size={isMobileOnly ? 'fullscreen' : 'tiny'}
      className={isMobileOnly ? 'mobile' : ''}
      open={open}
      style={{ zIndex: 1000000 }}
    >
      {!isMobileOnly && <Modal.Header>{text('AccountingSystemMappingUpdate')}</Modal.Header>}
      <Modal.Content
        style={isMobileOnly ? { overflowY: 'auto' } : { maxHeight: 600 }}
      >
        <Form size='small'>
          <Form.Group
            unstackable
            widths={'equal'}
            style={{ flexWrap: 'wrap', gap: '1em' }}>
            <Form.Field
              control={HotelsDropDown}
              data={hotels}
              clearable fluid required
              label={text("Hotel")}
              key="HotelId"
              value={row.HotelId}
              onChange={onChange.bind(null, 'HotelId')}
            />
            <Form.Field
              control={TransactionsDropDown}
              data={transactionData}
              clearable fluid required
              label={text("TransactionCode")}
              key="TransactionCode"
              value={row.TransactionCodeId}
              spec={{ IsDebit: true, IsActive: true, HotelId: row.HotelId }}
              onChange={onChange.bind(null, 'TransactionCodeId')}
              disabled={!row.HotelId}
            />
            <Form.Field
              control={EntityTypesDropDown}
             // data={hotels}
              clearable fluid required
              label={text("EntityType")}
              key="EntityType"
              value={row.EntityTypeId}
              entityTypeIds={[EntityType.Room, EntityType.RoomType,EntityType.Wings,EntityType.MarketSegment]}
              onChange={onChange.bind(null, 'EntityTypeId')}
              disabled={!row.HotelId}
            />
          
            <Form.Field
              label={dynamicEntityLabel(row)}
              fluid
              control={DynamicEntityDropDown}
              EntityTypeId={row.EntityTypeId}
              value={row.EntityId}
              disabled={!row.EntityTypeId}
              data={dynamicEntityDropDownData(row)}
              clearable
              onChange={onChange.bind(null, 'EntityId')}
              required
            />
            <Form.Field
              control={TextInput}
              clearable fluid required
              label={text("AccountingSystemNum")}
              key="AccountingSystemNum"
              value={row.AccountingSystemNum}
              onChange={onChange.bind(null, 'AccountingSystemNum')}
            />
          </Form.Group>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          size={isMobileOnly ? 'tiny' : 'small'}
          negative
          onClick={onCancelChanges}>
          {text('Cancel')}
        </Button>
        <Button
          size={isMobileOnly ? 'tiny' : 'small'}
          disabled={isSaveDisabled()}
          positive
          onClick={onApplyChanges}>
          {text('OK')}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

EditModal.propTypes = {
  extendedProps: PropTypes.object,
  row: PropTypes.object,
  onCancelChanges: PropTypes.func,
  onApplyChanges: PropTypes.func,
  onChange: PropTypes.func,
  open: PropTypes.bool,
  onDeleteRow: PropTypes.func,
};
